import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import ActionGetSPV from '../../store/action/Supervisor/FetchAll'
import ActionGet from '../../store/action/HelpdeskCs/Fetch'
import ActionGetDetail from '../../store/action/HelpdeskCs/View'
import ActionDelete from '../../store/action/HelpdeskCs/Delete'
import CustomGridSearch from '../../infra/components/grid/custom-grid-with-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView, InputTypeDropdown } from '../../store/constants'
import { toast } from "react-toastify";
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Helpdesk-CS",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-6' ,id: 'search', placeholder: 'Search', label : '', value:'' },
                { widthClass:'col-sm-6' ,id: 'spv-id', placeholder: 'Supervisor', label : '', value:'', inputType: InputTypeDropdown, data: fromJS([]) },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "", field: "cs-name", caption: "CS Name", allowSearch: true },
                { className : "col-sm-2", cfield: "action", caption: "Actions", allowView: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    componentDidMount(){
        this.props.actionGetSPV();
        const { formSearch } = this.state;
        this.refreshGrid(1, formSearch);
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.props.actionGet();
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    async handleEditClicked(value){
        var param = value;

        var response = await this.props.actionGetDetail(value.get('cs-id'))
        if(response.ok){
            //debugger;
            var data = fromJS(await response.json());
            data = data.get('query-result');
            param = param.set("cs-id", data.get('cs-id'))
            param = param.set("spv-id", data.get('spv-id'))
            param = param.set("cs-name", data.get('cs-name'))
            param = param.set("username", data.get('username'))
            param = param.set("status", data.get('status'))
        }
        
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: param
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.props.actionGet(page, search);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.supervisorsall != null && props.supervisorsall.size > 0){
            var newSearch = state.search;
            // eslint-disable-next-line array-callback-return
            newSearch = newSearch.map((val) => {
                if(val.get('id') === 'spv-id'){
                    if(val.get('data').size === 0){
                        var options = fromJS([]);
                        var i = 0;
                        props.supervisorsall.map((value) => {
                            options = options.set(i, fromJS({ 'label': value.get('spv-name'), 'value': value.get('spv-id') }));
                            i++;
                        });
                        val = val.set('data', options);
                    }
                }
                return val;
            });
            return { search: newSearch };
        }

        return null;
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "cs-id":value.get('cs-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('cs-name') +' Success!', toast.POSITION.TOP_RIGHT);
            this.refreshGrid(1, this.state.formSearch);
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('cs-name') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.helpdeskcs ? fromJS(this.props.helpdeskcs) : fromJS({});

            return (

                <CustomGridSearch 
                    title="Privilege"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleNew={ this.handleNew }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGridSearch>
            )
        }
    }

    render(){
        const { form } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Customer Service"  : "Edit Customer Service"  ) : "Customer Service";
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                    {
                        this.showContent()
                    }
            </div>

            // <div className="card">
            //     <div className="header">    
            //         <h2>
            //             { title }
            //         </h2>
            //     </div>
            //     {
            //         this.showContent()
            //     }
            // </div>
        );
    }
}


export default connect(
  (state) => {
      return {
        helpdeskcs: state.user.helpdeskcs,
        supervisorsall: state.user.supervisorsall
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
      actionGetSPV: ActionGetSPV,
      actionGetDetail: ActionGetDetail
  }, dispatch),
)(Page);